import {
  CareCategories,
  ProviderTypes,
  ReverseCoverageTypesCodes,
} from '../../common/Constants';

export interface ChipState {
  chipValue: string;
  originalChipValue: string;
  coverageType: string;
  lob: string;
  locale: string;
  openRecentActivity: boolean;
  openSpecialtyDrawer: boolean;
  openAllSpecialtyDrawer: boolean;
  landedOnDetailsPageFromSearch: boolean;
  providerTypeBehavioralHealth: ProviderTypes;
  setChipValue: (chipValue: string) => void;
  setOriginalChipValue: (originalChipValue: string) => void;
  setCoverageType: (coverageType: string) => void;
  setLob: (lob: string) => void;
  setLocale: (locale: string) => void;
  setOpenRecentActivity: (openRecentActivity: boolean) => void;
  setOpenSpecialtyDrawer: (openSpecialtyDrawer: boolean) => void;
  setOpenAllSpecialtyDrawer: (openAllSpecialtyDrawer: boolean) => void;
  setLandedOnDetailsPageFromSearch: (
    landedOnDetailsPageFromSearch: boolean
  ) => void;
  clearLandedOnDetailsPageFromSearch: () => void;
  setProviderTypeBehavioralHealth: (
    providerTypeBehavioralHealth: ProviderTypes
  ) => void;
}

export enum StoreKeys {
  CHIP_VALUE = 'chipValue',
  ORIGINAL_CHIP_VALUE = 'originalChipValue',
  COVERAGE_TYPE = 'coverageType',
  LOB = 'lob',
  LOCALE = 'locale',
  OPEN_RECENT_ACTIVITY = 'openRecentActivity',
  OPEN_SPECIALTY_DRAWER = 'openSpecialtyDrawer',
  OPEN_ALL_SPECIALTY_DRAWER = 'openAllSpecialtyDrawer',
  LANDED_ON_DETAILS_PAGE_FROM_SEARCH = 'landedOnDetailsPageFromSearch',
  SET_CHIP_VALUE = 'setChipValue',
  SET_ORIGINAL_CHIP_VALUE = 'setOriginalChipValue',
  SET_COVERAGE_TYPE = 'setCoverageType',
  SET_LOB = 'setLob',
  SET_LOCALE = 'setLocale',
  SET_OPEN_RECENT_ACTIVITY = 'setOpenRecentActivity',
  SET_OPEN_SPECIALTY_DRAWER = 'setOpenSpecialtyDrawer',
  SET_OPEN_ALL_SPECIALTY_DRAWER = 'setOpenAllSpecialtyDrawer',
  SET_LANDED_ON_DETAILS_PAGE_FROM_SEARCH = 'setLandedOnDetailsPageFromSearch',
  CLEAR_LANDED_ON_DETAILS_PAGE_FROM_SEARCH = 'clearLandedOnDetailsPageFromSearch',
  SET_PROVIDER_TYPE_BEHAVIORAL_HEALTH = 'setProviderTypeBehavioralHealth',
}

export const initialState = {
  [StoreKeys.CHIP_VALUE]: CareCategories.ALL,
  [StoreKeys.COVERAGE_TYPE]: ReverseCoverageTypesCodes.MEDICAL,
};

export const PERSIST_KEYS = [
  StoreKeys.CHIP_VALUE,
  StoreKeys.ORIGINAL_CHIP_VALUE,
  StoreKeys.COVERAGE_TYPE,
  StoreKeys.LOB,
  StoreKeys.LOCALE,
  StoreKeys.LANDED_ON_DETAILS_PAGE_FROM_SEARCH,
];
